import Avatar from '@mui/material/Avatar';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import AILogoSimpleIcon from 'assets/icons/quicken-ai/ai-logo-simple.inline.svg';

const useStyles = makeStyles()((theme) => ({
  avatar: {
    background: theme.palette.ai.gradientRadial,
    color: theme.palette.common.white,
  },
}));

type AIAvatarProps = {
  name?: string;
  src?: string;
  width?: number;
  height?: number;
};

export const AIAvatar: React.FC<AIAvatarProps> = ({ width = 32, height = 32 }) => {
  const { classes } = useStyles();

  return (
    <Avatar className={classes.avatar} alt={'AI'} sx={{ width, height }}>
      <AILogoSimpleIcon />
    </Avatar>
  );
};
